
module.exports =
  metaInfo:
    title: 'How to start using HoneyMoney' #70 characters
    meta: [
      { name: 'description', content: 'The easiest and quickest way' }
    ]
